export type PrizmDecimal = 'not-zero' | 'always' | 'never';
